/* eslint-disable */

import React, { Component } from 'react';
import QuillLocalStorage from 'core/utils/localStorageClient';
import {
  FormControl,
  FormLabel,
  FormGroup,
  Checkbox,
  Tooltip,
  FormControlLabel,
} from '@quillbot/design-system';
import withStyles from '@mui/styles/withStyles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { APP_SETTINGS } from 'config/constants';
import clsx from 'clsx';
const LocalStorage = QuillLocalStorage.getInstance();
import { theme } from 'config/theme';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  margin: {
    marginLeft: theme.spacing(2),
  },
  checkListlabel: {
    fontWeight: 600,
    marginBottom: '10px',
    fontSize: '14px',
  },
  matIcon: {
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  icon: {
    borderRadius: 2,
    width: 16,
    height: 16,
    border: `2px solid ${theme.specialColors.CHECKBOX_DEFAULT}`,
  },
  disabledIcon: {
    borderRadius: 2,
    width: 16,
    height: 16,
    border: `2px solid ${theme.palette.divider}`,
  },
  extensionHolder: {
    position: 'relative',
    minWidth: 125,
    height: '25px',
    borderRadius: '5px',
    padding: '8px 0px',
    width: '90%',
    maxWidth: '180px',
  },
  extBtnLabel: {
    position: 'absolute',
    top: '50%',
    left: 'calc(50% - 12px)',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    marginLeft: '9px',
    transform: 'translate(-50%, -50%)',
    fontSize: '14px',
    color: theme.palette.text.main,
    height: '40px',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.dark,
      '& $arrowIcon': {
        color: theme.palette.primary.dark,
      },
    },
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      width: '100%',
      paddingLeft: '17px',
    },
  },
  checkedIcon: {
    border: 'none',
    backgroundColor: theme.palette.primary.main,
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  formControl: {
    marginTop: '15px',
    width: '100%',
  },
  arrowIcon: {
    marginTop: 2,
    transition: '0.3s',
  },
  menuItem: {
    '&:hover': {},
  },
  tooltip: {
    '& p': {
      color: theme.specialColors.CIRCULAR_PROGRESS,
    },
  },
});

const GreenCheckbox = withStyles({
  root: {
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

class SettingsDrawer extends Component {
  constructor(props) {
    super(props);
  }

  renderCheckbox = (label, prop, tooltip, alwaysUnchecked, disabled) => {
    const { classes } = this.props;
    let isChecked = false;

    if (this.props?.pphrSettingsState?.hasOwnProperty(prop)) {
      isChecked = this.props?.pphrSettingsState[prop];
    } else if (APP_SETTINGS.hasOwnProperty(prop)) {
      isChecked = APP_SETTINGS[prop];
    } else if (this.props.paraphraseSettings?.hasOwnProperty(prop)) {
      isChecked = this.props.paraphraseSettings[prop];
    } else {
      isChecked = LocalStorage.get('gcFluencyModeEnabled', 'true') === 'false' ? false : true;
    }

    return (
      <>
        <FormControlLabel
          control={
            <GreenCheckbox
              checked={alwaysUnchecked ? false : isChecked}
              onChange={(event) => this.props.handleChange(event, prop)}
              value={prop}
              disabled={disabled || alwaysUnchecked}
              checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
              icon={
                <span
                  className={disabled || alwaysUnchecked ? classes.disabledIcon : classes.icon}
                />
              }
            />
          }
          label={
            tooltip ? (
              <span style={{ fontSize: '14px' }}>
                {label}
                <Tooltip
                  placement="bottom-start"
                  title={tooltip}
                  classes={{ tooltip: classes.tooltip }}>
                  <InfoOutlinedIcon
                    color="primary"
                    style={{ marginTop: '-1px', marginLeft: '2px' }}
                    className={classes.matIcon}
                  />
                </Tooltip>
              </span>
            ) : (
              <span classes={classes.tooltipSpans} style={{ fontSize: '14px' }}>
                {label}
              </span>
            )
          }
        />
      </>
    );
  };

  renderElements = () => {
    const { classes } = this.props;

    return this.props.checkboxesToShow.map((elements) => {
      const title = Object.keys(elements);
      return (
        <>
          <FormLabel
            component="legend"
            className={classes.checkListlabel}
            style={{ marginTop: '15px' }}>
            {title}
          </FormLabel>
          <div className={classes.checkListlabel}>
            {elements[title].map((data) => {
              const {label, prop, tooltip, alwaysUnchecked, disabled} = data;
              return (
                <FormGroup className={`${classes.margin}`}>
                  {label !== 'Show Scrollbar' &&
                    this.renderCheckbox(label, prop, tooltip, alwaysUnchecked, disabled)}
                  {this.props?.mode?.isExtension &&
                  this.props?.mode?.extensionMetaData?.type === 'ms-word' &&
                  label === 'Show Scrollbar'
                    ? this.renderCheckbox(label, prop, tooltip, alwaysUnchecked, disabled)
                    : null}
                </FormGroup>
              );
            })}
          </div>
        </>
      );
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div style={{ display: 'relative' }}>
        <FormControl component="fieldset" className={classes.formControl} focused={false}>
          {this.renderElements()}
        </FormControl>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SettingsDrawer);
